<template>
    <div class="registration-succsess__wrapper">
        <div class="registration-succsess__header">
            <div class="registration-succsess__title">
                {{ $t('success') | capitalize }}
            </div>
        </div>
        <div class="notice">
            {{ $t('The registration form was sent successfully. Check your e-mail and complete' +
                ' the registration process. Thank you') }}
        </div>
        <Illustration xl image="/static/img/illustrations/email__sent.svg"/>
    </div>
</template>

<script>
    export default {};
</script>



// WEBPACK FOOTER //
// src/app/modules/authentication/components/register/Header.vue